// @ts-check
/* eslint no-console: off*/
/**
 * @function
 * @name filterLocale
 * Filter an array of nodes by a specific i18n locale
 * @param {Array} array - The edge array of node objects
 * @param {string} locale [locale=en-AU] - i18n locale code
 * @returns {Array<Object>} array of object nodes
 */
export default function filterLocale(array, locale) {
	const i18n = locale
	try {
		if (!i18n) throw '@param {string} locale - is empty'
		if (!array || !Array.isArray(array) || array.length === 0) return [{ node: {} }]
		/** Array.prototype.filter() */
		const filtered = array.filter(edge => edge && edge.node && edge.node.node_locale === i18n)
		return filtered.length > 0 ? filtered : [{ node: {} }]
	} catch (err) {
		console.error(err)
		return [{ node: {} }]
	}
}
